import React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import styles from "./DeliveryHistoryModal.module.scss";
import {
  getOrderDeliveries,
  getDeliveryHistoryOrderId,
  toggleDeliveryHistoryModal,
  setDeliveryHistoryOrderId,
} from "../../features/orders/ordersSlice";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import moment from "moment";

type Props = {
  handleExportPaymentPdf: (paymentId: number) => void;
};

const DeliveryHistoryModal = ({ handleExportPaymentPdf }: Props) => {
  const dispatch = useAppDispatch();
  const orderDeliveries = useAppSelector(getOrderDeliveries);
  const orderId = useAppSelector(getDeliveryHistoryOrderId);

  const handleClose = () => {
    dispatch(toggleDeliveryHistoryModal(false));
    dispatch(setDeliveryHistoryOrderId(null));
  };

  return (
    <div className={styles.DeliveryHistoryModal}>
      <div className="relative h-[100vh] w-[100vw] overflow-y-scroll lg:overflow-auto top-0 lg:top-10 lg:mx-auto p-5 border lg:w-[600px] lg:h-fit shadow-lg lg:rounded-md bg-white">
        <div className="mt-3">
          <h3 className="text-2xl text-center font-bold leading-6 text-primary-1">
            Delivery History - Order #{orderId}
          </h3>
          <div className="mt-4">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-base text-primary-1 font-bold uppercase tracking-wider">
                      Sr. No.
                    </th>
                    <th className="px-6 py-3 text-left text-base text-primary-1 font-bold uppercase tracking-wider">
                      PID
                    </th>
                    <th className="px-6 py-3 text-right text-base text-primary-1 font-bold uppercase tracking-wider">
                      Qty
                    </th>
                    <th className="px-6 py-3 text-left text-base text-primary-1 font-bold uppercase tracking-wider">
                      Date
                    </th>
                    <th className="px-6 py-3 text-right text-base text-primary-1 font-bold uppercase tracking-wider">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {orderDeliveries.length > 0 ? (
                    orderDeliveries.map((delivery: any, index: number) => (
                      <tr key={index}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {index + 1}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {delivery.payment_id || "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-right">
                          {delivery.qty}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {moment(delivery.created_at).format(
                            "DD-MM-YYYY hh:mm A"
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                          {delivery.payment_id ? (
                            <button
                              onClick={() =>
                                handleExportPaymentPdf(delivery.payment_id)
                              }
                              className="text-indigo-600 hover:text-indigo-900"
                            >
                              <FaFileInvoiceDollar className="text-xl text-primary-1" />
                            </button>
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={5}
                        className="text-primary-2 font-bold text-xl text-center py-2"
                      >
                        No delivery history found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="mt-4 text-center">
              <button
                className="mx-auto shadow rounded-3xl text-3xl lg:text-xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                type="button"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryHistoryModal;
